import { Link } from 'react-router-dom';
import { ArrowLeft, Home } from 'lucide-react';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import { useIsInsideAppLayout } from '../components/AppLayoutContext';
import Seo from '../seo/Seo';
import { getSeoContent, getSeoFaqSchema } from '../seo/seoContentData';
import ToolSeoSections from '../components/ToolSeoSections';
import CollapsibleSeoContent from '../components/seo/CollapsibleSeoContent';

function FloorPlanCreatePlaceholderPage({ publicSeo = null }) {
  const isInsideAppLayout = useIsInsideAppLayout();
  const backToToolsPath = publicSeo ? '/ai-tools/ai-2d-floorplan-to-3d' : '/projects';
  const backToToolsLabel = publicSeo ? 'Explore floor plan tools' : 'Back to projects';

  return (
    <>
      <Seo
        title={publicSeo?.title || 'AI Floor Plan Creator | MyRoomsAI'}
        description={publicSeo?.description || 'Describe home details and let AI generate a 2D floor plan.'}
        canonicalPath={publicSeo?.path || '/projects/ai-2d-floorplan-creator'}
        noindex={!publicSeo}
        structuredData={[getSeoFaqSchema(publicSeo?.path)].filter(Boolean)}
      />
      {!isInsideAppLayout ? <Navbar /> : null}
      <main className="dashboard-page tool-hub-placeholder-page">
        <div className="container">
          <header className="dashboard-page-toolbar dashboard-header">
            <Link
              to={backToToolsPath}
              className="project-result-btn project-result-btn--secondary dashboard-header-projects-link"
            >
              <ArrowLeft size={18} strokeWidth={2} aria-hidden />
              {backToToolsLabel}
            </Link>
          </header>

          <article className="card tool-hub-placeholder-card">
            <div className="tool-hub-placeholder-icon" aria-hidden="true">
              <Home size={36} strokeWidth={1.75} />
            </div>
            <h1 className="dashboard-page-heading">{publicSeo?.h1 || 'AI Floor Plan Creator'}</h1>
            {publicSeo?.headingSubtext ? (
              <p className="new-design-workspace-preview-heading-subtext">{publicSeo.headingSubtext}</p>
            ) : null}
            <p className="tool-hub-placeholder-desc">
              Describe home details and let AI generate a 2D floor plan.
            </p>
            <p className="tool-hub-placeholder-note">
              This feature is coming soon. Check back for updates.
            </p>
            <Link to={backToToolsPath} className="btn btn-primary">
              {backToToolsLabel}
            </Link>
          </article>
          {publicSeo ? <ToolSeoSections {...publicSeo} /> : null}
          {publicSeo ? <CollapsibleSeoContent {...getSeoContent(publicSeo.path)} /> : null}
        </div>
      </main>
      {!isInsideAppLayout ? <Footer /> : null}
    </>
  );
}

export default FloorPlanCreatePlaceholderPage;
